import dayjs, { Dayjs } from "dayjs"
import { DrawStatus, IDraw } from "./draw.types"

export class Draw implements IDraw {
  constructor(
    public id: string,
    public name: string,
    public startDateTime: Dayjs,
    public entryDeadlineDateTime: Dayjs,
    public completionDateTime: Dayjs,
  ) {}

  getStatus(now: Dayjs = dayjs()): DrawStatus {
    if (now.isBefore(this.startDateTime)) return "upcoming"
    if (now.isBefore(this.entryDeadlineDateTime)) return "active"
    return "closed"
  }
}
